import { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Row, Col, Button, Input, Label } from "reactstrap/lib";
import { CreateNewScormLicenseCustomer } from "../../actions/superUserMutations";
import { GetLicenseManagementCustomers } from "../../actions/superUserQueries";
import { useMutation, useQueryClient, useQuery } from "react-query";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import { getErrorMessage } from "../../Utilities/getErrorMessage";

function LicMgtCreateCustomerModal({ toggle, isOpen, intl }) {
  const [postDisabled, setPostDisabled] = useState(false);
  const handleNewScormLicenseCustomer = useMutation(
    CreateNewScormLicenseCustomer
  );
  const [newCustomer, setNewCustomer] = useState({
    url: null,
    fortnoxNumber: null,
  });
  const [errors, setErrors] = useState([]);

  const licenseCustomers = useQuery(
    "FetchLicenseManagementCustomers",
    GetLicenseManagementCustomers()
  );

  const queryClient = useQueryClient();

  useEffect(() => {
    if (newCustomer.url != null && newCustomer.url.length > 1) {
      setErrors((e) => e.filter((item) => item !== "url"));
    }
    if (
      newCustomer.fortnoxNumber != null &&
      newCustomer.fortnoxNumber.length > 1
    ) {
      setErrors((e) => e.filter((item) => item !== "fortnoxNumber"));
    }
  }, [newCustomer]);

  const postNewCustomer = () => {
    setPostDisabled(true);
    if (
      newCustomer.url == null ||
      newCustomer.url.length < 1 ||
      newCustomer.fortnoxNumber == null ||
      newCustomer.fortnoxNumber.length < 1
    ) {
      if (newCustomer.url == null || newCustomer.url.length < 1) {
        if (!errors.includes("url")) {
          setErrors([...errors, "url"]);
        }
      }
      if (
        newCustomer.fortnoxNumber == null ||
        newCustomer.fortnoxNumber.length < 1
      ) {
        if (!errors.includes("fortnoxNumber")) {
          setErrors([...errors, "fortnoxNumber"]);
        }
      }
    } else {
      handleNewScormLicenseCustomer.mutate(
        {
          ...newCustomer,
        },
        {
          onSuccess: (data) => {
            if (data && data.status > 199 && data.status < 300) {
              toast.success(intl.formatMessage({ id: "CustomerCreated" }));
              queryClient.setQueryData(
                ["FetchLicenseManagementCustomers"],
                [...licenseCustomers.data, data.data.result]
              );
              setPostDisabled(false);
              toggle();
            } else {
              setPostDisabled(false);
              let errorMessage = <FormattedMessage id="GeneralError" />;
              if (data?.response?.data) {
                errorMessage = getErrorMessage(data.response.data);
              }
              toast.warn(errorMessage);
            }
          },
          throwOnError: true,
          onError: (err) => {
            setPostDisabled(false);
            let errorMessage = <FormattedMessage id="GeneralError" />;
            if (err) {
              errorMessage = getErrorMessage(err);
            }
            toast.warn(errorMessage);
          },
        }
      );
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <FormattedMessage id="CreateNewCustomer" />
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col className="col-md-8 my-auto">
            <Label for="customerName" className="mb-0">
              <FormattedMessage id="FortnoxNumber" />:
            </Label>
            <Input
              name="customerName"
              onChange={(event) =>
                setNewCustomer({
                  ...newCustomer,
                  fortnoxNumber: event.target.value,
                })
              }
              type="text"
            ></Input>
          </Col>
        </Row>
        <Row className="pt-3">
          <Col className="col-md-8 my-auto">
            <Label for="customerUrl" className="mb-0">
              <FormattedMessage id="Url" />:
            </Label>
            <Input
              name="customerName"
              onChange={(event) =>
                setNewCustomer({ ...newCustomer, url: event.target.value })
              }
              type="text"
            ></Input>
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="col-md-8 my-auto">
            <Label for="customerContactName" className="mb-0">
              <FormattedMessage id="NameOfContactPerson" />:
            </Label>
            <Input
              name="customerContactName"
              onChange={(event) =>
                setNewCustomer({
                  ...newCustomer,
                  contactName: event.target.value,
                })
              }
              type="text"
            ></Input>
          </Col>
        </Row>
        <Row className="pt-3">
          <Col className="col-md-8 my-auto">
            <Label for="customerContactMail" className="mb-0">
              <FormattedMessage id="Email" />:
            </Label>
            <Input
              name="customerContactMail"
              onChange={(event) =>
                setNewCustomer({
                  ...newCustomer,
                  contactMail: event.target.value,
                })
              }
              type="text"
            ></Input>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          <FormattedMessage id="Close" />
        </Button>
        <Button
          onClick={() => postNewCustomer()}
          disabled={postDisabled}
          outline
          color="primary"
        >
          <FormattedMessage id="Save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
export default injectIntl(LicMgtCreateCustomerModal);
